import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { useTheme } from '@mui/material/styles';
import { GradientBorder } from '../gradients/GradientBorder';

export type MintGuidePanelProps = {
  steps: (JSX.Element | string)[];
};

export function MintGuidePanel({ steps }: MintGuidePanelProps) {
  const theme = useTheme();
  return (
    <GradientBorder
      borderRadius="10px"
      sx={{
        borderWidth: '1px',
        boxShadow: theme.shadows[2],
        '&:hover': {
          boxShadow: theme.shadows[4],
        },
      }}
    >
      <Stack
        gap="4px"
        direction="column"
        alignItems="stretch"
        justifyContent="center"
        textAlign="left"
        sx={{
          paddingX: '24px',
          paddingY: '12px',
        }}
      >
        <GradientTypography
          gradientColor="primary.vertical"
          variant="h5"
          sx={{ textTransform: 'uppercase' }}
        >
          Mint Guide
        </GradientTypography>
        <ol
          style={{
            paddingLeft: '16px',
            paddingBottom: '4px',
            textAlign: 'left',
            margin: 0,
            fontWeight: 'bold',
          }}
        >
          {steps.map((step, i) => (
            <li key={`${step.toString()}-${i}`}>
              <Typography variant="subtitle1">{step}</Typography>
            </li>
          ))}
        </ol>
      </Stack>
    </GradientBorder>
  );
}
